<template>
  <form @submit.prevent="onSubmit">
    <div class="input-box">
      <label for="email">
        Email <span>*</span>
      </label>
      <input v-model="formData.email" id="email" type="text" placeholder="Enter email" />
      <span v-if="errors.email" class="error-message">{{ errors.email }}</span>
    </div>

    <div class="input-box">
      <label for="password">
        Password <span>*</span>
      </label>
      <input
        v-model="formData.password"
        id="password"
        type="password"
        placeholder="Enter password..."
      />
      <span v-if="errors.password" class="error-message">{{ errors.password }}</span>
    </div>

    <div class="login-action mb-10 fix">
      <span class="log-rem f-left">
        <input v-model="formData.remember" id="remember" type="checkbox" />
        <label for="remember">Remember me</label>
      </span>
      <span class="forgot-login f-right">
        <a href="#">Lost your password?</a>
      </span>
    </div>
    <button type="submit" class="tp-in-btn w-100">Log in</button>
  </form>
</template>

<script>
import { toast } from "vue3-toastify";

export default {
  data() {
    return {
      formData: {
        username: '',
        password: '',
        remember: false,
      },
      errors: {
        username: '',
        password: '',
      },
    };
  },
  methods: {
    // Form submission handler
    async onSubmit() {
      // Clear previous errors
      this.errors = {
        username: '',
        password: '',
      };

      // Simple client-side validation
      if (!this.formData.email) {
        this.errors.email = 'Email is required';
      } else if (!/\S+@\S+\.\S+/.test(this.formData.email)) {
        this.errors.email = 'Enter a valid email';
      }
      if (!this.formData.password) this.errors.password = 'Password is required';

      if (Object.values(this.errors).some(error => error)) return;

      try {
        // Debugging log to ensure data is being sent
        console.log('Sending data:', this.formData);  // Add this log to inspect data

        // Send login request
        const response = await this.$axios.post('/login', this.formData); // Make sure the URL is correct

        // Store the token in localStorage
        localStorage.setItem('auth_token', response.data.token);

        // Store user details in localStorage or sessionStorage
        localStorage.setItem('user', JSON.stringify(response.data.user));

        toast.success('Login successful!');
        //this.$router.push({ name: 'Checkout' }); // Redirect to user section
        window.location.href = '/checkout';
      } catch (error) {
        console.log('Login error:', error.response?.data);  // Log error for better debugging
        toast.error('Login failed: ' + (error.response?.data.message || 'Please try again.'));
      }
    },
  },
};
</script>

<style scoped>
.error-message {
  color: red;
  font-size: 12px;
}
</style>
